export function defaultArt(){
  return '/brand/icon.svg';
}
